import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const AlignedCol = styled(Col)`
  && {
    display: flex;
    justify-content: flex-end;
    white-space: nowrap;
  }
`;

export const PaddedCol = styled(Col)`
  && {
    padding: ${spacing('lg')};
  }
`;

export const $ImportantHighlight = styled('span')`
  ${fontStyle('base')};
  font-weight: bold;
`;

export const Date = styled('div')`
  margin-left: ${spacing('xs')};
  font-weight: ${fontWeight('bold')};
`;
